<!-- ----------------------------------------------------------------------- -->
<!--                       ANCHOR DIV ONLY FOR TITLES                        -->
<!-- ----------------------------------------------------------------------- -->
<div 
   *ngIf="menuItem.isTitle && hasPermission(menuItem) && !rightMenuService.toggleMenu"
   class="col-12 text-title text-uppercase ps-3 mb-3">
   {{ menuItem.label | translate }}
</div>

<div 
   *ngIf="menuItem.isTitle && hasPermission(menuItem)"
   class="col-12 text-title text-uppercase ps-3 mb-3 d-block d-md-none">
   {{ menuItem.label | translate }}
</div>

<!-- ----------------------------------------------------------------------- -->
<!--                     SECTION FOR ITEMS HAVE SUBITEMS                     -->
<!-- ----------------------------------------------------------------------- -->
<div
   class="d-none d-md-block">
   <button
      *ngIf="menuItem.subItems && hasPermission(menuItem)"
      (click)="isCollapsed = !isCollapsed; rightMenuService.toggle(menuItem)"
      [attr.aria-expanded]="!isCollapsed"
      class="btn d-flex align-items-center col-12"
      [ngClass]="{
         'justify-content-between': !rightMenuService.toggleMenu,
         'align-items-center': rightMenuService.toggleMenu
      }">
      <i 
         class="bx {{menuItem.icon}} sidebar-icon" 
         *ngIf="menuItem.icon"
         [ngClass]="{
            'me-2': !rightMenuService.toggleMenu,
            'mx-auto': rightMenuService.toggleMenu
         }"></i>
      <span 
         *ngIf="!rightMenuService.toggleMenu"
         class="text-white"
         style="font-size: 13px;">
         {{ menuItem.label | translate }}
      </span>
      <i 
         *ngIf="!rightMenuService.toggleMenu"
         class="material-icons ms-auto"
         style="color: #babfc4; font-size: 1.2rem;">
         {{isCollapsed ? 'chevron_right' : 'expand_more'}}
      </i>
   </button>
</div>

<!-- ----------------------------------------------------------------------- -->
<!--                        ANCHOR BUTTON FOR MOBILE                         -->
<!-- ----------------------------------------------------------------------- -->

<button
   *ngIf="menuItem.subItems && hasPermission(menuItem)"
   (click)="isCollapsed = !isCollapsed"
   [attr.aria-expanded]="!isCollapsed"
   class="btn d-flex align-items-center justify-content-between col-12 d-block d-md-none">
   <i 
      class="bx {{menuItem.icon}} sidebar-icon me-2" 
      *ngIf="menuItem.icon"></i>
   <span 
      class="text-white"
      style="font-size: 13px;">
      {{ menuItem.label | translate }}
   </span>
   <i 
      class="material-icons ms-auto"
      style="color: #babfc4; font-size: 1.2rem;">
      {{isCollapsed ? 'chevron_right' : 'expand_more'}}
   </i>
</button>

<div
   *ngIf="menuItem.subItems && hasPermission(menuItem)"
   #collapse="ngbCollapse"
   [(ngbCollapse)]="isCollapsed">
   
   <div class="col-12 ps-4 pt-2">
      <app-sidebar-item
            *ngFor="let menuSubItem of menuItem.subItems"
            [menuItem]="menuSubItem">
      </app-sidebar-item>
   </div>
</div>
<!-- ------------------------------ !SECTION ------------------------------- -->

<!-- ----------------------------------------------------------------------- -->
<!--                             ANCHOR SUBITEMS                             -->
<!-- ----------------------------------------------------------------------- -->
<a
   *ngIf="!menuItem.subItems && !menuItem.isTitle && hasPermission(menuItem)"
   [routerLink]="menuItem.link" 
   class="col-12 mb-2 d-block">
   <span 
      class="text-subtitle ps-4"
      style="font-size: 13px;">
      {{ menuItem.label | translate }}
   </span>
</a>